<script>
  import { Handle, Position } from "@xyflow/svelte";
  import { fly } from "svelte/transition";

  export let data;
  export let isConnectable = false;
  export let id;

  let {
    label,
    icon,
    isStart,
    isEnd,
    color,
    handlemodal,
    position,
    seeIcon = true,
    seeButton = true,
  } = data;

  $: isSelected = data.isSelected;
  $: displayLabel = sanitizeLabelHtml(label);

  $$restProps;

  function handleClick(e) {
    e.preventDefault();
    handlemodal(e, id);
  }

  function cleanTechnicalText(value) {
    const tempTextArea = document.createElement("textarea");
    tempTextArea.innerHTML = value || "";
    return tempTextArea.value
      .replace(/\u00a0/g, " ")
      .replace(/&nbsp;/gi, " ")
      .replace(/[\u200B-\u200D\uFEFF\u00AD]/g, "")
      .replace(/[\u202A-\u202E\u2066-\u2069]/g, "")
      .replace(/\uFFFD/g, "")
      .replace(/<{2,3}\s*([^<>]+?)\s*>{2,3}/g, "$1")
      .replace(/[ \t]+/g, " ");
  }

  function sanitizeLabelHtml(html) {
    const tempDivElement = document.createElement("div");
    tempDivElement.innerHTML = html || "";
    const walker = document.createTreeWalker(
      tempDivElement,
      NodeFilter.SHOW_TEXT,
    );
    let node;
    while ((node = walker.nextNode())) {
      node.nodeValue = cleanTechnicalText(node.nodeValue);
    }
    return tempDivElement.innerHTML;
  }

  function htmlToText(html) {
    const tempDivElement = document.createElement("div");
    tempDivElement.innerHTML = sanitizeLabelHtml(html);
    const parts = tempDivElement.innerHTML.split("<br>");
    const windowTitleAndElement = parts
      .slice(-2)
      .map((part) => {
        const textElement = document.createElement("div");
        textElement.innerHTML = part;
        return cleanTechnicalText(textElement.textContent).trim();
      })
      .join("\n");
    return windowTitleAndElement || "";
  }
</script>

{#if isStart}
  <Handle
    type="source"
    position={Position.Bottom}
    style="background: #555;"
    {isConnectable}
    class="customHandle"
  />
{:else}
  <Handle
    type="target"
    position={Position.Top}
    style="background: #555;"
    {isConnectable}
    class="customHandle"
  />
{/if}
<div class="container">
  <div
    data-node-id={id}
    class="custom-node {isStart || isEnd ? 'start-end-node' : ''}
  {isSelected ? 'selected' : ''} {(isStart || isEnd) && !seeIcon
      ? 'no-icon'
      : ''}"
    style={`background: ${!isStart && !isEnd ? color : ""};`}
    in:fly={{ x: position.x, y: position.y, duration: 500 }}
  >
    {#if seeIcon}
      <img
        src={icon}
        alt="icon"
        width="35"
        height="30"
        style={isStart || isEnd ? "filter: invert(1);" : ""}
      />
    {:else}
      <div class="icon-placeholder"></div>
    {/if}
    <span class="label-node" title={htmlToText(label)}
      >{@html displayLabel}</span
    >
    {#if !isEnd && !isStart && seeButton}
      <button on:click={handleClick}>
        <img
          alt="icon button"
          class="more_filled_icon undefined"
          src="/img/ui_icons/more.svg"
          width="30"
          height="30"
        />
      </button>
    {/if}
  </div>
</div>

{#if !isStart && !isEnd}
  <Handle
    type="source"
    position={Position.Bottom}
    style="background: #555; cursor: pointer;"
    {isConnectable}
    class="customHandle"
  />
{/if}

<style>
  .container {
    width: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .custom-node {
    display: flex;
    font-size: 14px;
    align-items: center;
    justify-content: space-between;
    padding: 14px 16px;
    border: 2px solid #000;
    border-radius: 8px;
    gap: 8px;
  }

  .custom-node:hover {
    border: 2px solid #ff5f1f;
  }

  :global(.svelte-flow__node .node_hovered) {
    stroke: #ff5f1f !important;
  }

  .selected {
    border: 2px solid #5c25fa;
  }

  .start-end-node {
    background: #000;
    border: 2px solid #000;
    border-radius: 10px;
    color: #fff;
  }

  :global(div.customHandle) {
    border-radius: 0;
    transform: none;
    border: none;
    opacity: 0;
  }

  .label-node {
    max-width: 340px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 1px 0;
  }

  .no-icon {
    padding-right: 35px;
    padding-left: 30px;
  }

  .icon-placeholder {
    height: 30px;
    display: inline-block;
  }
</style>
